export const LANG_EN_NAME = 'en';

export const LANG_EN_TRANS = {
  'app.title': 'D Clean Admin'
};



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/core/translate/lang-en.ts